(function () {
  'use strict';

  // Cursor — RAF + transform (GPU composited, no layout)
  const cur = document.querySelector('.hk-cursor');
  const curf = document.querySelector('.hk-cursor-follow');
  if (cur && curf && window.matchMedia('(pointer:fine)').matches) {
    let mx = 0, my = 0, rafPending = false;
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      if (!rafPending) {
        rafPending = true;
        requestAnimationFrame(function () {
          cur.style.transform = 'translate(' + mx + 'px,' + my + 'px)';
          curf.style.transform = 'translate(' + mx + 'px,' + my + 'px)';
          rafPending = false;
        });
      }
    }, { passive: true });
  }

  // Scroll reveal — IntersectionObserver (no scroll listener)
  const revealEls = document.querySelectorAll('.hk-reveal');
  if (revealEls.length > 0 && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('hk-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.07, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('hk-in'); });
  }

  // FAQ accordion
  document.querySelectorAll('.hk-faq__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item = btn.closest('.hk-faq__item');
      const wasOpen = item.classList.contains('hk-open');
      document.querySelectorAll('.hk-faq__item').forEach(function (i) { i.classList.remove('hk-open'); });
      if (!wasOpen) item.classList.add('hk-open');
    });
  });

  // Video carousel
  document.querySelectorAll('.hk-videos').forEach(function (section) {
    const track = section.querySelector('.hk-videos__track');
    if (!track) return;
    const cards = track.querySelectorAll('.hk-videos__card');
    if (!cards.length) return;
    const cardWidth = cards[0].offsetWidth + 20;
    let pos = 0;
    const max = Math.max(0, cards.length - 2);

    section.querySelector('.hk-videos__prev')?.addEventListener('click', function () {
      pos = Math.max(pos - 1, 0);
      track.style.transform = 'translateX(-' + (pos * cardWidth) + 'px)';
    });
    section.querySelector('.hk-videos__next')?.addEventListener('click', function () {
      pos = Math.min(pos + 1, max);
      track.style.transform = 'translateX(-' + (pos * cardWidth) + 'px)';
    });
  });

  // Product tabs
  document.querySelectorAll('.hk-products__tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      const parent = tab.closest('.hk-products');
      parent.querySelectorAll('.hk-products__tab').forEach(function (t) { t.classList.remove('hk-active'); });
      tab.classList.add('hk-active');
    });
  });

  // Marquee speed via CSS var
  document.querySelectorAll('.hk-marquee').forEach(function (el) {
    const speed = el.dataset.speed;
    if (speed) el.style.setProperty('--hk-marquee-speed', speed + 's');
  });

})();
